import cssVars from 'css-vars-ponyfill';

import services from './services.js';
import verticalTabs from './vertical-tabs.js';
import scrollProgressbar from './scroll-progressbar.js';
import WhatWeDo from '../blocks/whatWeDo.js';

// Import Owl Carousel 2 lib (added with `yarn add owl.carousel2`)
import 'owl.carousel2/dist/assets/owl.carousel.min.css';
import 'owl.carousel2/dist/owl.carousel.min.js';
import 'select2/dist/js/select2.min.js';

import equalizeElementHeight from '../util/equalizeElementHeight';
import LottieAnimation from '../components/lottie-animation';
import Testimonials from '../blocks/testimonials.js';
import Hero from '../blocks/hero.js';
import Partners from '../blocks/partners.js';
import Root from '../components/root.js';
import { Header } from '../blocks/header.js';
import { MegaMenuTabs } from '../blocks/megaMenuTabs.js';
import ContentColumns from '../blocks/contentColumns.js';
import { TextMediaScrollHijack } from '../blocks/textMediaScrollHijack.js';
import ContentCarousel from '../blocks/contentCarousel.js';
import Awards from '../blocks/awards.js';
import Video from '../components/video.js';
import NewFaq from '../blocks/newFaq.js';
import TransitionInView from '../components/transitionInView.js';
import TeamMembers from '../blocks/teamMembers.js';

export default {
  init() {
    headerSticky();
    glossaryScroll();
    hotJobsSlider();
    linkBoxesSlider();
    resourcesSlider();
    caseStudiesSlider();
    //careersSubmitForm();
    maxMegaMenu();
    teamMembersOverlay();
    modalOverlay();

    let hotJobs = $('.b-hot-jobs__items');
    let linkBoxes = $('.b-link-boxes__items');
    let resourcesItems = $('.c-af-resource-card');
    let caseStudies = $('.b-af-case-studies__item');

    if ( hotJobs.length > 0 || linkBoxes.length > 0 ) {
      $(window).resize(function () {
        if ( $(window).width() > 992 ) {
          if ( hotJobs ) {
            hotJobs.data('owl.carousel').destroy();
            hotJobs.removeClass('owl-carousel');
          }
          if ( linkBoxes ) {
            linkBoxes.data('owl.carousel').destroy();
            linkBoxes.removeClass('owl-carousel');
          }
        }
        else {
          hotJobsSlider();
          linkBoxesSlider();
        }
      });
    }

    if ( resourcesItems.length > 0 ) {
      $(window).resize(function () {
        resourcesSlider();
      });
    }

    if ( caseStudies.length > 0 ) {
      $(window).resize(function () {
        caseStudiesSlider();
      });
    }

    // Initialize CSS Variables ponyfill (https://github.com/jhildenbiddle/css-vars-ponyfill)
    cssVars();

    window.onscroll = () => {
      headerSticky();
    };

    // Included Scripts
    services.init();
    verticalTabs.init();
    scrollProgressbar.init();

    // Language switcher
    $('.wpml-ls-item').click(function(event) {
      if ( $(window).width() <= 1199 ) {
        $(this).find('.sub-menu').toggle();

        if ( event.target != $('.wpml-ls-item .sub-menu')[0] && $('.wpml-ls-item .sub-menu').has(event.target).length === 0 ) {
          return false;
        }
      }
    });

    $('body').click(function() {
      $('.wpml-ls-item .sub-menu').hide();
    });

    var lastScrollTop = 0;
    $(window).scroll(function(){
      var st = $(this).scrollTop();

      if (st > lastScrollTop){
        $('.menu-top').slideUp();
      } else {
        $('.menu-top').slideDown();
      }

      lastScrollTop = st;
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    if($('.client-slides').length) {
      $('.client-slides').slick({
        dots: true,
        speed: 1000,
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        mobileFirst: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              prevArrow: "<span class='left-arrow-mobile'></span>",
              nextArrow: "<span class='right-arrow-mobile'></span>",
            },
          },
        ],
      });
    }

    $(".next-sec").click(function() {
      $('html, body').animate({ scrollTop: $(".section").next().offset().top }, 'slow');
    });

    $('#nav-icon').click(function(){
      $(this).toggleClass('open');
      $('body').toggleClass('lock-scroll');
    });

    $('.section-navigation-search .icon_link').click(function() {
      $('.icon_link').removeClass('active');
      $(this).addClass('active');
      var activeClass = $(this).attr('href').substring(1);
      if(activeClass != 'all') {
        var notBlurClass = ".article_card_"+ activeClass;

        $('.articles').children().removeClass('d-none');
        $('.articles').children().not(notBlurClass).addClass('d-none');
        // console.log(notBlurClass);
      } else {
        $('.articles').children().removeClass('d-none');
      }
    });

    // Section: Slider button and image
    var slider_btn_and_image = $('.slick-slider-btn-and-image');
    slider_btn_and_image.owlCarousel({
      autoplay: false,
      center: true,
      loop: true,
      items: 1,
      dots: true,
      nav: true,
      navText : ["<span class='left-arrow-mobile'></span>","<span class='right-arrow-mobile'></span>"],
      onInitialized: (event) => {
        const $leftArrow = $(event.target).siblings('.left-arrow');
        const $rightArrow = $(event.target).siblings('.right-arrow');

        /**
         * Now that the slider has been initialized, we can show the prev/next buttons
         * If we show the buttons before the slider has been initialized, they will jump
         * as the slider loads and its full height is realized.
         */
        if($leftArrow.length > 0) {
          $leftArrow.removeClass('d-none');
        }

        if($rightArrow.length > 0) {
          $rightArrow.removeClass('d-none');
        }

        slider_btn_and_image.removeClass('slick-slider-btn-and-image--loading');
      },
    })

    var slider_btn_and_image_autoplay = setInterval(function() {
      $('.slick-slider-btn-and-image').trigger('next.owl.carousel');
    }, 6000);

    // Copy Owl dots
    $('.slick-slider-btn-and-image .new-nav').html($('.slick-slider-btn-and-image>.owl-dots').html());
    $('.slick-slider-btn-and-image .new-nav .owl-dot').removeClass('active');
    $('.slick-slider-btn-and-image .new-nav').each(function(){
      var active = $(this).data('active');
      $(this).find('.owl-dot:nth-child('+active+')').addClass('active');
    })

    // Dots click event!
    $('.slick-slider-btn-and-image .new-nav .owl-dot').click(function(){
      var index = $(this).prevAll().length + 1;
      $('.slick-slider-btn-and-image>.owl-dots .owl-dot:nth-child('+index+')').click();
    })

    // Arrows click event!
    $('.slider-btn-and-image .left-arrow').click(function(){
      $('.slick-slider-btn-and-image').trigger('prev.owl.carousel');
    })

    $('.slider-btn-and-image .right-arrow').click(function(){
      $('.slick-slider-btn-and-image').trigger('next.owl.carousel');
    })

    // Stop Autoplay
    $(document).on("click", ".slider-btn-and-image", function(){
      clearInterval(slider_btn_and_image_autoplay);
    });

    // Play Video
    $(document).on("click", ".slick-slider-btn-and-image .video-cont .play, .single-slide-with-image-button .video-cont .play" ,function(event) {
      event.preventDefault();

      var video_cont = $(this).parent().parent();
      var video_html = video_cont.attr("data-video");
      video_cont.html(video_html);

      $('.slick-slider-btn-and-image .video-cont').addClass('video-is-playing');

      clearInterval(slider_btn_and_image_autoplay);
    });

    slider_btn_and_image.on('changed.owl.carousel', function() {
      $(".slick-slider-btn-and-image .video-cont").each(function(){

        var thumb = $(this).attr("data-thumb");
        $(this).html(thumb);
        $(this).removeClass('video-is-playing');
      });
    });

    // Section: Slider with focus
    $('.slick-slider-with-focus').owlCarousel({
      autoplay: false,
      autoplaySpeed: 1000,
      center: true,
      loop: true,
      items:5,

      responsive : {
        // breakpoint from 0 up
        0 : {
            items:1,
            dots:true,
            stagePadding: 70,
            margin:10,
        },
        // breakpoint from 480 up
        480 : {
            items:1,
            dots:true,
            stagePadding: 70,
        },
        // breakpoint from 768 up
        768 : {
            items:5,
            dots:false,
            slideBy:2,
        },
      },
    });

    // Section: Square slider
    $('.square-slider .intro-slider').owlCarousel({
      items:1,
      nav:true,
      dots:false,
      loop:true,
      smartSpeed: 1000,
      navText: ["<img src='/wp-content/themes/cyberproof/resources/assets/images/left.png'>","<img src='/wp-content/themes/cyberproof/resources/assets/images/right.png'>"],
    });

    // Section: Careers list
    var filterSelectCareer = $('.js-careers-filters-select');

    // Init custom dropdown/select
    filterSelectCareer.select2({
      dropdownParent: filterSelectCareer.parent(),
      minimumResultsForSearch: 10,
    });

    // Update filter on dropdown/select change
    filterSelectCareer.on('change', () => {
      $('.js-careers-filters-form').submit();
    });

    // Section: Team
    var filterSelectTeam = $('.js-team-filter-select');

    // Init custom dropdown/select
    filterSelectTeam.select2({
      dropdownParent: filterSelectTeam.parent(),
      minimumResultsForSearch: 10,
    });

    // Update filter on dropdown/select change
    filterSelectTeam.on('change', () => {
      $('.js-team-filters-form').submit();
    });

    $.fn.attachDragger = function(){
      var attachment = false, lastPosition, position, difference;
      $( $(this).selector ).on("mousedown mouseup mousemove",function(e){
          if( e.type == "mousedown" ) attachment = true, lastPosition = e.clientX;
          if( e.type == "mouseup" ) attachment = false;
          if( e.type == "mousemove" && attachment == true ){
              position = e.clientX;
              difference = position-lastPosition;
              $(this).scrollLeft( $(this).scrollLeft() - difference );
              lastPosition = e.clientX;
          }
      });
      $(window).on("mouseup", function(){
          attachment = false;
      });
    }

    $('.resources-lobby .navigation-block-icons').attachDragger();

    $('.resources-lobby .navigation-block-icons img').on('dragstart', function(event) { event.preventDefault(); });
    $('.resources-lobby .navigation-block-icons a').on('dragstart', function(event) { event.preventDefault(); });


    // Image List Slider
    if($('.section-image-list').length){
      const section = $('.section-image-list');
      const imageList = section.find('.section-image-list__image-list');

      let slideCount = section.find('.section-image-list__image-item').length;

      if (slideCount <= 5) {
        imageList.children().clone(true, true).appendTo(imageList);
      }

      imageList.slick({
        autoplay: false,
          autoplaySpeed: 1000,
          center: true,
          loop: true,
          slidesToShow: 5,
          slidesToScroll: 4,
          infinite: true,
          dots: true,
          arrows: true,
          prevArrow: "<span class='left-arrow-mobile'></span>",
          nextArrow: "<span class='right-arrow-mobile'></span>",
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 2,
                dots: true,
              },
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true,
              },
            },
          ],
      });
    }

    /* HS gated modal (part of hero section) */
    $('.hs-gated-link').click(function(){
      $('.hs-gated-modal').css('display', 'flex');

      return false;
    });

    $('.hs-gated-modal').click(function(){
      $(this).hide();
    });

    $(document).on('click', '.hbspt-close, .hbspt-close img', function(){
      $('.hs-gated-modal').hide();
    });

    $('.hbspt-form').click(function(event){
      var target = $(event.target);
      if (!target.is('.hbspt-close, .hbspt-close img')) {
        event.stopPropagation();
      }
    });

    // Table of contents
    if ($('.page-toc').length) {
      $('.page-toc').append('<div class="close-button"></div>');

      const setTocTopPosition = () => {
        const tocTopBarHeight = 8;
        const headerHeight = $('header.banner').outerHeight();
        const topPosition = tocTopBarHeight + headerHeight;

        $('.page-toc').css('top', topPosition);
      }

      setTocTopPosition();

      $(window).on('resize scroll', setTocTopPosition);
    }

    $('.page-toc').click(function() {
      const toc = $(this);
      if (!toc.hasClass('active')) {
        toc.css('left', '0px');
        toc.addClass('active');
        toc.animate({'width':'350px'}, 50);
        setTimeout(() => {
          toc.find('.page-toc__items').collapse('show');
        }, 200);
        $('.page-toc__items').on('show.bs.collapse', function () {
          setTimeout(() => {
            toc.css('height', 'auto');
            toc.find('.close-button').fadeIn(200);
          }, 200);
        })
      }
    });

    $('.close-button').click(function() {
      const toc = $(this).parents('.page-toc');
      $(this).fadeOut(200, function() {
        toc.removeClass('active');
        toc.find('.page-toc__title').animate({'top':'0px', 'left': '0px'}, 200);
        toc.css('left', '66px');
        toc.animate({'width':'218px'}, 100);
        toc.find('.page-toc__items').collapse('hide');
      })
    });

    $('.page-toc__link').click(function(e) {
      e.preventDefault();
      const destination = $(this).attr('href');
      let destination_top = $(destination).offset().top;

      if( destination === '#section-two-column-list-4' ) {
        destination_top = destination_top - 150;
        window.scrollTo(0, destination_top);
      }
      else {
        window.scrollTo(0, destination_top);
      }

    });

    // Brochures
    equalizeElementHeight('.section-brochure', '.resource-text')

    // Core values
    equalizeElementHeight('.core-values', '.col-lg-4 p')

    // Careers lobby
    $('.b-careers-list-hero__select').change(function() {
      $('.b-careers-list__error').hide();

      $('.b-careers-list__job').each(function() {
        $(this).removeClass('active').removeClass('no-margin');
      });

      let activeLocation = $('.b-careers-list-hero__select--location').val();
      let activeDepartment = $('.b-careers-list-hero__select--department').val();
      // Adding Parametar for job location
      if(!activeLocation || activeLocation === '0'){
        window.history.replaceState(null, null, window.location.pathname);
      } else {
        window.history.replaceState(null, null, "#" + activeLocation);
      }

      $('.b-careers-list__job').each(function() {
        let jobLocation = $(this).attr('data-location');
        let jobDepartment = $(this).attr('data-department');

        if (activeLocation === null) {
          jobLocation = null;
        } else if (activeDepartment === null) {
          jobDepartment = null;
        }

        if (( jobLocation == activeLocation || activeLocation === "0" ) && ( jobDepartment == activeDepartment || activeDepartment === "0" )) {
          $(this).addClass('active');
        }
      });

      $('.b-careers-list__job.active').each(function(index, element) {
        if ((index + 1) % 3 == 0) {
          $(element).addClass('no-margin')
        }
      });

      let matchedJobs = $('.b-careers-list__job.active').length;

      if (matchedJobs == 0) {
        $('.b-careers-list__error').show();
      }
    })

    // Checking url for Jobs Location
    if (window.location.href.indexOf('#') > -1) {
      var location = window.location.href.split('#')[1];

      if(location) {
        $(".b-careers-list-hero__select--location + .select2 .select2-selection__rendered").text(location);
      }

      $('.b-careers-list__error').hide();

      $('.b-careers-list__job').each(function() {
        $(this).removeClass('active').removeClass('no-margin');
      });

      let activeLocation = location;
      let activeDepartment = $('.b-careers-list-hero__select--department').val();

      $('.b-careers-list__job').each(function() {
        let jobLocation = $(this).attr('data-location');
        let jobDepartment = $(this).attr('data-department');

        if (activeLocation === null) {
          jobLocation = null;
        } else if (activeDepartment === null) {
          jobDepartment = null;
        }

        if (( jobLocation == activeLocation || activeLocation === "0" ) && ( jobDepartment == activeDepartment || activeDepartment === "0" )) {
          $(this).addClass('active');
        }
      });

      $('.b-careers-list__job.active').each(function(index, element) {
        if ((index + 1) % 3 == 0) {
          $(element).addClass('no-margin')
        }
      });

      let matchedJobs = $('.b-careers-list__job.active').length;

      if (matchedJobs == 0) {
        $('.b-careers-list__error').show();
      }
    }


    $('.back-to-top').click(function() {
      $([document.documentElement, document.body]).animate({
        scrollTop: 0,
      }, 2000);
    })
  },
};

let headerSticky = () => {
  const header = document.querySelector('.js-header');
  const darkHeaderTrigger = document.querySelector('.js-hero-blog');
  const toc = $('.js-toc');
  const sticky = 1;

  if (!header) {
    return;
  }

  if (darkHeaderTrigger) {
    header.classList.add('dark-header');
  }

  // For when the header should start already sticky
  const forceSticky = $(header).hasClass('force-sticky');

  if (forceSticky || window.pageYOffset >= sticky) {
    header.classList.add('is-sticky');
    toc.addClass('is-sticky');
    toc.removeClass('d-none');
  } else {
    header.classList.remove('is-sticky');
    toc.addClass('d-none');
    toc.removeClass('is-sticky');
  }
};

let glossaryScroll = () => {
  $('.glossary-scroll').click(function(e){
    e.preventDefault();

    let target = $(this).attr('href');

    window.scrollTo(0, $(target).offset().top - 150);
  });
};

// eslint-disable-next-line no-unused-vars
const careersSubmitForm = () => {
  $('.b-careers-position__form form').submit(function(e){
    e.preventDefault();

    const form = $(this).closest('form');

    let formData = new FormData();

    const fields = form.find('input[type="text"], input[type="email"], textarea');
    fields.each(function(){
      formData.append( $(this).attr('name'), $(this).val() );
    });

    const resume = form.find('input[name="resume"]')[0].files;
    const cover_letter = form.find('input[name="cover_letter"]')[0].files;
    const portfolio = form.find('input[name="portfolio"]')[0].files;

    formData.append( 'resume', resume[0] );
    formData.append( 'cover_letter', cover_letter[0] );
    formData.append( 'portfolio', portfolio[0] );

    const data = {
      details: formData,
      // eslint-disable-next-line no-undef
      security: afAjax.security,
      contentType: false,
      processData: false,
      // eslint-disable-next-line comma-dangle
      action: 'af_comeet_candidate'
    }

    // eslint-disable-next-line no-undef
    $.post(afAjax.ajaxurl, data, function(response){
      console.log(response);
    });
  });
};

const hotJobsSlider = () => {
  if ( $(window).width() >= 992 ) {
    return false;
  }

  const jobItems = $('.b-hot-jobs__items');

  if ( jobItems.length < 1 ) {
    return;
  }

  jobItems.addClass('owl-carousel');

  jobItems.owlCarousel({
    items: 1,
    margin: 10,
    stagePadding: 50,
    center: true,
    responsive:{
      450:{
        items:3,
      },
    },
  });
};

const linkBoxesSlider = () => {
  if ( $(window).width() >= 992 ) {
    return false;
  }

  const boxItems = $('.b-link-boxes__items');

  if ( boxItems.length < 1 ) {
    return;
  }

  boxItems.addClass('owl-carousel');

  boxItems.owlCarousel({
    items: 1,
    margin: 10,
    stagePadding: 50,
    center: true,
    autoWidth:true,
    responsive:{
      350:{
        stagePadding: 95,
      },
      576:{
        stagePadding: 50,
        margin: 30,
      },
    },
  });
};

const resourcesSlider = () => {
  const resourcesItems = $('.b-af-resources__body--slider');

  if ( resourcesItems.length < 1 || $(window).width() >= 768) {
    return;
  }

  resourcesItems.each(function() {
    var $this = $(this);
    const resourcePause = $this.data('pause');
    const resourceFree = $this.data('free-move');

    $this.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: resourcePause ? true : false,
      swipe: resourceFree ? true : false,
      dots: true,
      autoplaySpeed: 2000,
    });

  })

}



const caseStudiesSlider = () => {
  const caseStudiesItems = $('.b-af-case-studies__case_studies');

  if ( caseStudiesItems.length < 1 || $(window).width() >= 768) {
    return;
  }

  caseStudiesItems.each(function() {
    var $this = $(this);
    // const resourcePause = $this.data('pause');
    // const resourceFree = $this.data('free-move');

    $this.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      swipe: true,
      dots: true,
      autoplaySpeed: 8000,
      centerPadding: '30px',
    });

  })

}

// Max Mega menu
const maxMegaMenu = () => {
  // Wait for Max Mega Menu
  function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(() => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });
  }

  waitForElm('.max-mega-menu').then(() => {
    const navbar = $('.navbar');
    const megaMenuItem = $('.mega-menu > .mega-menu-item');
    const subMenu = $('.mega-menu-item > ul.mega-sub-menu');
    const subMenuButLast = $('.mega-menu-item:not(:last-of-type) > ul.mega-sub-menu');
    const burgerBtn = $('.mega-toggle-animated');

    /*
    * Desktop rules
    *
    */
    $(window).on('load resize', function() {
      if ( $(window).width() >= 992 ) {
        // Add button classes to last menu item
        $('.mega-menu > .menu-cta a').addClass('c-btn c-btn--secondary');
        $('.mega-menu > .menu-cta a').removeClass('mega-menu-link c-btn--primary c-btn--with-arrow');

        // Reverse engineering mobile logic on window resize for desktop
        megaMenuItem.removeClass('hide');
        subMenu.removeClass('submenu-position');

        if (subMenuButLast.find('a.c-btn--with-arrow').length) {
          subMenuButLast.find('a.c-btn--with-arrow').remove();
        }

        if ($('.btn-back').length) {
          $('.btn-back').remove();
          navbar.find('.navbar-brand').removeClass('no-display');
        }

      /*
      * Mobile rules
      *
      */
      } else {
        // Main menu logic
        $(document).on('click', '.mega-menu > .mega-menu-item > .mega-menu-link', function() {
          if ( $(window).width() < 992 ) {
            megaMenuItem.addClass('hide');
            subMenu.addClass('submenu-position');

            if ($('.btn-back').length < 1) {
              navbar.prepend('<span class="btn-back">< Back</span>');
              navbar.find('.navbar-brand').addClass('no-display');
            }
          }
        });

        // Submenu and back button logic
        $(document).on('click', '.btn-back', function() {
          megaMenuItem.removeClass('hide');
          navbar.find('.mega-toggle-on').removeClass('mega-toggle-on');

          $('.btn-back').remove();
          navbar.find('.navbar-brand').removeClass('no-display');
        });

        // Reset on menu close
        burgerBtn.on("click", function() {
          if ($('.btn-back').length) {
            $('.btn-back').remove();
            navbar.find('.navbar-brand').removeClass('no-display');
            megaMenuItem.removeClass('hide');
            navbar.find('.mega-toggle-on').removeClass('mega-toggle-on');
          }
        });

        // Add button classes to last menu item in mobile main menu
        $('.mega-menu > .menu-cta a').addClass('c-btn c-btn--primary c-btn--with-arrow');
        $('.mega-menu > .menu-cta a').removeClass('mega-menu-link c-btn--secondary');

        if (subMenuButLast.find('a.c-btn--with-arrow').length < 1) {
          subMenuButLast.append('<a class="c-btn c-btn--primary c-btn--with-arrow" href="https://go.cyberproof.com/talk-to-an-expert">Speak with an Expert</a>');
        }
      }
    });

    /*
    * Mobile and Desktop rules
    *
    */

    // Add button classes to menu items in footer
    $('.footer-nav > .menu-item:last-of-type a').addClass('c-btn c-btn--secondary c-btn--with-arrow c-btn--arrow-colored');

    // Change language switcher current language name to 2 character
    let langSwitch = $('.mega-menu > .mega-wpml-ls-item > .mega-menu-link span:first-of-type').html();
    const subString = langSwitch.substring(0, 2);
    $('.mega-menu > .mega-wpml-ls-item > .mega-menu-link span:first-of-type').html(subString);
  });
};

// Team members overlay
const teamMembersOverlay = () => {
  // Open overlay
  $(document).on('click', '.section-team__item', function() {
    $(this).find('.section-team__overlay').addClass('open');
    $('html').css('overflow','hidden');
  });

  // Close overlay
  $(document).on('click', '.section-team__overlay-close', function(e) {
    e.stopPropagation();
    $(this).parent('.section-team__overlay').removeClass('open');
    $('html').css('overflow','visible');
  });
};

// Learn more cards modal overlay
const modalOverlay = () => {
  let selector = '.component-link-card';
  let modalSelector = '.component-modal'
  // let modalSelector = '.'
  // Open overlay
  $(document).on('click', selector + '__modal-trigger', function() {
    $(this).parent().find( modalSelector + '__overlay').addClass('open');
    $('html').css('overflow','hidden');
  });

  // Close overlay
  $(document).on('click', modalSelector + '__overlay-close', function(e) {
    e.stopPropagation();
    $(this).parent().parent().parent(modalSelector + '__overlay').removeClass('open');
    $('html').css('overflow','visible');
  });
};

window.addEventListener('DOMContentLoaded', () => {
  // Load hero before lotties to ensure correct init of animations
  new Hero();

  new Video();

  // Lotties should load first
  new LottieAnimation();
  new WhatWeDo().init();
  new ContentColumns();
  new TextMediaScrollHijack();
  new ContentCarousel();
  new Awards();

  new Root();
  new Header();
  new Testimonials();
  new Partners();
  new MegaMenuTabs();
  new NewFaq();
  new TransitionInView();
  new TeamMembers();
});



// WEBPACK FOOTER //
// ./scripts/routes/common.js